import { Box, Typography } from '@mui/material';
import Table from './Table.jsx';
import dayjs from 'dayjs';
import StatusInvoice from 'pages/PublicPage/VerifyCertificateSubscriptions/StatusInvoice.jsx';

const InvoicesTable = ({ data = [], onClickViewInvoice }) => {
  return (
    <Table
      rows={data}
      theme="light"
      hidePagination
      sx={{
        background: 'none',
        '& td': {
          border: '2px solid #EFEFEF',
          borderStyle: 'solid none',
          background: 'white',
        },
      }}
      label_sx={{
        fontSize: 12,
      }}
      columns={[
        {
          id: 'invoiceNumber',
          label: 'INVOICE NUMBER',
          minWidth: 150,
          render: ({ invoiceNumber }) => (
            <Typography fontWeight={700} fontSize={12}>
              {invoiceNumber}
            </Typography>
          ),
        },
        {
          id: 'description',
          label: 'DESCRIPTION',
          render: ({ bucket }) => (
            <Typography fontSize={12}>
              {bucket.credits} credits/{bucket.price.toLocaleString()} UGX
            </Typography>
          ),
        },
        {
          id: 'status',
          label: 'STATUS',
          minWidth: 120,
          render: ({ status }) => <StatusInvoice status={status} />,
        },
        {
          id: 'action',
          label: '',
          minWidth: 120,
          render: (item) => (
            <Box fontSize={12}>
              <Typography fontSize={10}>
                {dayjs(item.createdAt).format('MMM DD, YYYY')}
              </Typography>
              <Typography
                color={'rgba(94, 196, 172, 1)'}
                fontSize={12}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={() => onClickViewInvoice(item)}
              >
                View invoice
              </Typography>
            </Box>
          ),
        },
      ]}
    />
  );
};

export default InvoicesTable;
